import LoginComponent, {
  LoginComponentProps,
} from 'app/LoginManagement/LoginComponent'

const LoginPage = (props: LoginComponentProps) => {
  const { currentStep } = props
  return <LoginComponent currentStep={currentStep} />
}

export default LoginPage
